'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExchangeRates = function (_React$Component) {
	_inherits(ExchangeRates, _React$Component);

	function ExchangeRates(props) {
		_classCallCheck(this, ExchangeRates);

		var _this = _possibleConstructorReturn(this, (ExchangeRates.__proto__ || Object.getPrototypeOf(ExchangeRates)).call(this, props));

		_this.state = {
			rates: JSON.parse(JSON.stringify(RATES)),
			loading: false,
			saving: 0
		};

		_this.renderRates = _this._renderRates.bind(_this);
		_this.handleValueChange = _this._handleValueChange.bind(_this);
		_this.handleBlur = _this._handleBlur.bind(_this);
		_this.handleAddSeason = _this._handleAddSeason.bind(_this);
		_this.fillMissingSeasons = _this._fillMissingSeasons.bind(_this);
		return _this;
	}

	_createClass(ExchangeRates, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.fillMissingSeasons();
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'exchange-rates' },
				_react2.default.createElement(
					'div',
					{ className: 'fx-header' },
					_react2.default.createElement(
						'div',
						{ className: 'btn btn-success', onClick: this.handleAddSeason },
						' ',
						_react2.default.createElement('i', { className: 'fa fa-plus' }),
						' Add Another Season'
					),
					_react2.default.createElement(
						'div',
						{ className: 'pull-right' },
						this.state.saving > 0 && _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin' })
					)
				),
				this.renderRates()
			);
		}
	}, {
		key: '_renderRates',
		value: function _renderRates() {
			var this$1 = this;

			var rate, year;
			var returnArray = [];
			var lastYear = '000';

			for (var i = 0; i < this.state.rates.length; i++) {
				rate = this$1.state.rates[i];
				year = rate.identifier.toString().substr(0, 4);
				if (year !== lastYear) {
					returnArray.push(_react2.default.createElement(
						'div',
						{ className: 'rates-row header', key: year },
						_react2.default.createElement(
							'div',
							{ className: 'rates-cell name' },
							year
						),
						_react2.default.createElement(
							'div',
							{ className: 'rates-cell gbp' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'rates-cell eur' },
							'EUR'
						),
						_react2.default.createElement(
							'div',
							{ className: 'rates-cell usd' },
							'USD'
						)
					));
					lastYear = year;
				}

				returnArray.push(_react2.default.createElement(
					'div',
					{ className: 'rates-row', key: rate.identifier },
					_react2.default.createElement(
						'div',
						{ className: 'rates-cell name' },
						rate.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'rates-cell gbp' },
						'\xA31'
					),
					_react2.default.createElement(
						'div',
						{ className: 'rates-cell curr-labels' },
						_react2.default.createElement(
							'div',
							{ className: 'curr-label' },
							'Initial'
						),
						_react2.default.createElement(
							'div',
							{ className: 'curr-label' },
							'Final'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'rates-cell eur' },
						_react2.default.createElement('input', {
							placeholder: 'EUR Initial',
							type: 'text',
							value: rate.eur_initial || '',
							onChange: this$1.handleValueChange.bind(null, i, 'eur_initial'),
							onBlur: this$1.handleBlur.bind(null, i, 'eur_initial')
						}),
						_react2.default.createElement('input', {
							placeholder: 'EUR Final',
							type: 'text',
							value: rate.eur_final || '',
							onChange: this$1.handleValueChange.bind(null, i, 'eur_final'),
							onBlur: this$1.handleBlur.bind(null, i, 'eur_final')
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'rates-cell usd' },
						_react2.default.createElement('input', {
							placeholder: 'USD Initial',
							type: 'text',
							value: rate.usd_initial || '',
							onChange: this$1.handleValueChange.bind(null, i, 'usd_initial'),
							onBlur: this$1.handleBlur.bind(null, i, 'usd_initial')
						}),
						_react2.default.createElement('input', {
							placeholder: 'USD Final',
							type: 'text',
							value: rate.usd_final || '',
							onChange: this$1.handleValueChange.bind(null, i, 'usd_final'),
							onBlur: this$1.handleBlur.bind(null, i, 'usd_final')
						})
					)
				));
			}
			return returnArray;
		}
	}, {
		key: '_handleAddSeason',
		value: function _handleAddSeason() {
			var newYear, newSeason;
			var lastYear = parseInt(this.state.rates[0].identifier.toString().substr(0, 4));
			var lastSeason = parseInt(this.state.rates[0].identifier.toString().charAt(4));
			// console.log(lastSeason);
			if (lastSeason === 4) {
				newYear = lastYear + 1;
				newSeason = 1;
			} else {
				newYear = lastYear;
				newSeason = lastSeason + 1;
			}

			newSeason = {
				name: this.intToShortName(newSeason) + newYear.toString().substr(2, 2),
				identifier: newYear.toString() + newSeason.toString() + '0',
				eur_initial: '',
				eur_final: '',
				usd_initial: '',
				usd_final: ''
			};

			var rates = [newSeason].concat(_toConsumableArray(this.state.rates));

			this.setState({
				rates: rates
			});
		}
	}, {
		key: 'intToShortName',
		value: function intToShortName(id) {

			var names = {
				'1': 'PS',
				'2': 'SS',
				'3': 'PA',
				'4': 'AW'
			};

			return names[id];
		}
	}, {
		key: 'shortNameToInt',
		value: function shortNameToInt(id) {
			var names = {
				'PS': 1,
				'SS': 2,
				'PA': 3,
				'AW': 4
			};

			return names[id];
		}
	}, {
		key: '_handleValueChange',
		value: function _handleValueChange(i, currency, e) {
			var rates = [].concat(_toConsumableArray(this.state.rates));
			rates[i][currency] = e.target.value;
			this.setState({
				rates: rates
			});
		}
	}, {
		key: '_handleBlur',
		value: function _handleBlur(i, currency, e) {
			var _this2 = this;

			this.setState({
				saving: this.state.saving + 1
			});

			var rate = this.state.rates[i];
			var data = {
				identifier: rate.identifier,
				currency: currency,
				value: e.target.value,
				_token: CSRF_TOKEN
			};

			_request2.default.post({
				url: location.origin + '/ajax/exchange_rate',
				form: data
			}, function (err, res, body) {
				if (err) {
					// console.log(err);
				} else {
						// console.log(body);
					}

				_this2.setState({
					saving: _this2.state.saving - 1
				});
			});
		}
	}, {
		key: '_fillMissingSeasons',
		value: function _fillMissingSeasons() {
			var this$1 = this;


			var lastYear = 0,
			    lastSeason = 0,
			    year,
			    season,
			    nextYear,
			    nextSeason,
			    newSeason,
			    actualNextYear,
			    actualNextSeason,
			    justInserted = 0,
			    rates = [].concat(_toConsumableArray(this.state.rates)),
			    newRates = [];

			for (var i = rates.length - 1; i >= 0; i--) {
				if (i === 0) {
					newRates.unshift(rates[i]);
					break;
				}

				newRates.unshift(rates[i]);

				year = parseInt(rates[i].identifier.toString().substr(0, 4));
				season = parseInt(rates[i].identifier.toString().charAt(4));

				actualNextYear = parseInt(rates[i - 1].identifier.toString().substr(0, 4));
				actualNextSeason = parseInt(rates[i - 1].identifier.toString().charAt(4));

				if (season === 4) {
					nextYear = year + 1;
					nextSeason = 1;
				} else {
					nextYear = year;
					nextSeason = season + 1;
				}

				while (actualNextSeason !== nextSeason || actualNextYear !== nextYear) {

					newRates.unshift({
						name: this$1.intToShortName(nextSeason) + nextYear.toString().substr(2, 2),
						identifier: nextYear.toString() + nextSeason.toString() + '0',
						eur_initial: '',
						eur_final: '',
						usd_initial: '',
						usd_final: ''
					});

					if (nextSeason === 4) {
						nextYear = nextYear + 1;
						nextSeason = 1;
					} else {
						nextSeason = nextSeason + 1;
					}
				}
			}

			this.setState({
				rates: newRates
			});
		}
	}]);

	return ExchangeRates;
}(_react2.default.Component);

exports.default = ExchangeRates;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/settings/ExchangeRates.js
// module id = 522
// module chunks = 0